export function handleResponsiveVideos() {
    const responsiveVideos = document.querySelectorAll("[data-responsive-video]");
    const mediaQuery = window.matchMedia("(min-width: 768px)");

    if (responsiveVideos.length > 0) {
        function handleVideoChange(e) {
            for (const video of responsiveVideos) {
                const portraitSrc = video.dataset.portrait;
                const landscapeSrc = video.dataset.landscape;
                
                // Check if the media query is true
                if (e.matches) {
                    video.setAttribute("src", landscapeSrc);
                    video.load();
                    // video.play();
                } else {
                    video.setAttribute("src", portraitSrc);
                    video.load();
                    // video.play()
                }
            }
        }

        // Register event listener
        mediaQuery.addEventListener("change", handleVideoChange)

        // Initial check
        handleVideoChange(mediaQuery)
    }
}